import styled from "styled-components";

export const DateInputWrapper = styled.div`
  grid-area: ${({ gridArea }) => gridArea};
  margin: ${({ margin }) => margin}px;

  position: relative;

  width: ${({ width }) => width};

  svg {
    cursor: pointer;
  }

  input {
    ::-webkit-calendar-picker-indicator {
      display: none;
    }
  }
`;
